export default __webpack_public_path__ + "static/media/How_To_Register.18fd9e4b.pdf";